// 二级品牌馆配置 长沙学院
export default {
  'ccsu.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788800000100001669710526',
      storeName: '长沙学院',
      microHost: 'ccsu-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788800000100001669710526',
      storeName: '长沙学院',
      microHost: 'ccsu-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800000100001669710526',
      storeName: '长沙学院',
      microHost: 'ccsu-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800000100001669710526',
      storeName: '长沙学院',
      microHost: 'ccsu-brand.ubanquan.cn'
    }
  }
};